import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

/* ----------------------- SELECTED MENU BUTTON STORE ----------------------- */
/* 
use for storing the selected menu button needed for style changes
*/

type SelectedMenuButtonState = {
  selectedMenu: string
}

type SelectedMenuButtonAction = {
  updateSelectedMenu: (id: string) => void
}

export const useSelectedMenuStore = create<
  SelectedMenuButtonState & SelectedMenuButtonAction
>()(
  persist(
    (set) => ({
      selectedMenu: null,
      updateSelectedMenu: (view: string) => set(() => ({ selectedMenu: view }))
    }),
    {
      name: 'selected-menu-view',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)

/* ----------------------- DESKTOP SIDE MENU STATE STORE ----------------------- */
/* 
use for storing if the desktop side menu is open to prevent refreshing its state between page renderings
*/

type DesktopSideMenuState = {
  isOpen: boolean
}

type DesktopSideMenuAction = {
  updateMenuIsOpen: (s: boolean) => void
}

export const useDesktopSideMenuStore = create<
  DesktopSideMenuState & DesktopSideMenuAction
>()(
  persist(
    (set) => ({
      isOpen: false,
      updateMenuIsOpen: (state: boolean) => set(() => ({ isOpen: state }))
    }),
    {
      name: 'side-menu-state',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
